import { render } from "./OverviewNote.vue?vue&type=template&id=3b9095ab&scoped=true"
import script from "./OverviewNote.vue?vue&type=script&lang=js"
export * from "./OverviewNote.vue?vue&type=script&lang=js"

import "./OverviewNote.vue?vue&type=style&index=0&id=3b9095ab&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9095ab"]])

export default __exports__